export const RECENTLY_RELEASED_DATA = {
  TRACK_DATA: "TRACK_DATA",
};